// extracted by mini-css-extract-plugin
module.exports = {"card":"ClubList_card__17Ycp","cardContent":"ClubList_cardContent__1oFSM"};